import { Button, Card } from "antd";
import img from "./../../../assets/images/icons/MakeupRemover.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import React, { useState } from "react";
import { MdArrowForward, MdArrowBack } from "react-icons/md";
import icons from "../../../constants/categoryIcons";

interface NightSkincareRoutineProps {
  data?: any;
  userName?: any;
  capitalize?: any;
    type?: string;
}

const iconsMap: any = {
  cleanser: icons["cleanser"],
  toner: icons["toner"],
  exfoliator: icons["exfoliator"],
  treatment: icons["treatment"],
  moisturizer: icons["moisturizer"],
  sunscreen: icons["sunscreen"],
  serum: icons["serum"],
  "eye cream": icons["eye cream"],
  "makeup remover": icons["makeup remover"],
  "face oil": icons["face oil"],
  mask: icons["mask"],
  "face mask": icons["face mask"],
};

const NightSkincareRoutine: React.FC<NightSkincareRoutineProps> = ({
  data,
  userName,
  capitalize,
   type,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [swiper, setSwiper] = useState<any>(null);
  console.log("type",type)
  return data && data?.length ? (
    <div className="morning-routine-skincare">
      
      <Card>
        {/* <h3 className="title">{userName}’s Expert-Built Night 🌙   Skincare Routine</h3> */}
         <h3 className="title">
          {userName}’s{" "}
          {type === "expert"
            ? "Expert-Built Night 🌙   Skincare Routine" // if survey_type = expert
            : "Night 🌙   Skincare Routine" // otherwise
          }
        </h3>
        <Swiper
          onSlideChange={(val: any) => {
            setCurrentIndex(val?.activeIndex);
          }}
          noSwiping={true}
          allowTouchMove={false}
          onSwiper={(swiper: any) => setSwiper(swiper)}
          navigation={false}
        >
          {data.map((item: any, i: number) => {
            const iconSrc = iconsMap[item.category?.toLowerCase()];
            return (
              <SwiperSlide key={i}>
                <div className="slider" key={i}>
                  <h1 className="how-use-subtitle">
                    Step {i + 1} {capitalize(item.category)}
                  </h1>
                  <img src={iconSrc ?? img} alt="" height={100} />
                  <h1 className="how-use-post-title">
                    {item?.isNewProduct === false
                      ? "Current Product - Keep Using"
                      : "Missing Skincare"}
                  </h1>
                  <h1 className="how-use-post-title">
                    {`${item?.isNewProduct !== false || item?.is_recommended ? "⭐ Recommended:" : ""} ${item?.brand ?? ""
                      }${item?.brand && item?.name ? " - " : ""}${item?.name ?? ""}`}
                  </h1>

                  <p className="description">{item?.note ?? item?.reason ?? ""}</p>
                </div>
              </SwiperSlide>
            );
          })}

          <div className="step-holder">
            <div className="steps">
              Step {currentIndex + 1}/{data?.length}
            </div>
          </div>
          <div className="product-sliders">
            <Button
              type="ghost"
              shape="circle"
              className="nav-prev-btn"
              size="small"
              onClick={() => {
                swiper?.slidePrev();
              }}
            >
              <MdArrowBack size={24} />
            </Button>
            <Button
              type="ghost"
              shape="circle"
              className="nav-prev-btn"
              size="small"
              onClick={() => {
                swiper?.slideNext();
              }}
            >
              <MdArrowForward size={24} />
            </Button>
          </div>
        </Swiper>
      </Card>
    </div>
  ) : null;
};

export default NightSkincareRoutine;
